module.exports = __webpack_public_path__ + "files/f2008aacf8a8d97812f4c0f1f7eb9efc.png";